import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {UtilConfig} from "app/autenticacion/servicios/UtilConfig";
import {AuthService} from "../servicios/auth.service";

declare var swal: any;
declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'recuperarClave',
    templateUrl: './view/recuperar-clave.component.html',
    styleUrls: ['./css/recuperar-clave.component.scss'],
    providers: [AuthService]
})
export class RecuperarClaveComponent implements OnInit {

    form: FormGroup;
    cargandoList = false;
    origenCRUD = "Recuperar Clave";
    username;
    ruc;
    vdl_ruc: FormControl;
    vld_username: FormControl;
    mensaje = false;

    constructor(private router: Router,
                private fb: FormBuilder,
                private authService: AuthService,
                private util: UtilConfig) {
        this.createFormControls();
        this.createForm();

    }


    ngOnInit() {
        $.getScript('/assets/autenticacion/js/recuperarClave.js');
    }

    createFormControls() {
        this.vdl_ruc = new FormControl({value: ""}, Validators.required);
        this.vld_username = new FormControl({value: ""}, Validators.required);
    }


    createForm() {
        this.form = this.fb.group({
            "ruc": this.vdl_ruc,
            "username": this.vld_username
        });
    }

    deshabilitarBoton(): boolean {
        return !this.form.valid;
    }

    recuperarClave() {
        // LLAMADO AL SERVICIO
        this.cargandoList = true;
        this.authService.recuperarClave(this.username, this.ruc)
            .subscribe(result => {

                if (result.codigo == 1)
                    this.mensaje = true;
                else
                    swal({
                        title: 'Error',
                        text: result.mensaje,
                        type: 'error',
                        showCancelButton: false,
                        confirmButtonText: 'Proceder!'
                    });
                this.cargandoList = false;
            }, err => {
                this.cargandoList = false;
                swal({
                    title: 'Error',
                    text: "El ruc y correo ingresado son incorrectos.",
                    type: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Proceder!'
                });
            });
    }


    irLogin() {
        this.router.navigate(['/']);
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/recuperarClave/recuperar-clave.component.ts